export default __webpack_public_path__ + "static/media/markedtarget.ba6cb0c2.png";